import React from 'react';
import { Window } from '../Window/Window';
import styled from 'styled-components';

const Container = styled.div`
  background: #C0C0C0;
  padding: 20px;
  height: calc(100% - 30px);
  font-family: 'Perfect DOS VGA 437', monospace;
  white-space: pre-wrap;
  line-height: 1.5;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 16px;
  }
  
  &::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-left: 1px solid #808080;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #808080;
    border: 1px solid #c0c0c0;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
`;

const Title = styled.h1`
  color: #000080;
  margin-bottom: 20px;
  text-align: center;
`;

const Section = styled.div`
  margin-bottom: 20px;
  line-height: 1.5;
`;

const Link = styled.a`
  color: #000080;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0000ff;
  }
`;

const Image = styled.img`
  width: 400px;
  height: auto;
  margin: 10px 0;
  border: 2px solid #808080;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

export const AppleFarmInfo = ({ 
  onClose, 
  isActive, 
  onActivate, 
  isMinimized, 
  isMaximized, 
  onMinimize, 
  onMaximize,
  initialPosition
}) => {
  return (
    <Window
      title="apple farm.txt"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      defaultWidth="600px"
      defaultHeight="500px"
      initialPosition={initialPosition}
    >
      <Container>
        <Title>apple farm - an incentive program on Etherlink</Title>
        
        <Section>
          <Image 
            src="/images/applefarmpic.png" 
            alt="Apple Farm illustration" 
          />
        </Section>

        <Section>
          back in mid to late 2024, we started thinking about how to bring more tvl, liquidity & activity to etherlink. incentives work, but most of them are either boring, inefficient, or just a straight-up farm-and-dump fest. that's why i (along with my colleagues) started building apple farm—an incentive program designed to reward actions that are actually good for the ecosystem, with a focus on DeFi.
        </Section>

        

        <Section>
          the idea: reward users based on what actually helps etherlink grow. providing liquidity? using lending markets? holding freaking uranium? all those things earn you apples (points, but with a fun name). we're building this with merkl, who make sure rewards go where they should.
        </Section>

        <Section>
          <b>how it came together:</b>
          <br />
          • $3,000,000 in rewards for season 1
          <br />
          • built with merkl for onchain reward distribution
          <br />
          • weighted actions so the right things get rewarded
          <br />
          • a simple, fun way to stack rewards without wrecking the ecosystem
        </Section>

        <Section>
          <Image 
            src="/images/afLOGO.svg" 
            alt="Apple Farm illustration" 
          />
        </Section>

        <Section>
          a project like this touches a lot of different things. i worked across almost every vertical at our Trilitech figuring out the incentives, making sure people actually understood them, and getting the right protocols to integrate with apple farm. also wrote a bunch of docs, answered way too many questions, and trying to make sure the thing actually launches.
        </Section>

        <Section>
          as etherlink and the incentives for apple farm are smaller than other programs, i really wanted to stand out with branding—which i think we definitely have succeeded with. this super cool pixelart style has really brought a lot of eyes towards the project, so that's a win.
        </Section>

        <Section>
          <b>challenges faced:</b>
          <br />
          • explaining how the farm works without making it sound like homework
          <br />
          • balancing rewards so it's attractive but not just a mercenary farm-fest
          <br />
          • making sure partners & dapps actually integrate and benefit from it
        </Section>


        <Section>
          <b>future:</b>
          <br />
          apple farm is just getting started. season 1 is live, and there's a lot more we can do:
          <br />
          • more integrations (more ways to earn apples)
          <br />
          • improving ux (making it easier to see what earns what)
          <br />
          • making sure the rewards keep flowing
        </Section>

        <Section>
          fun project, big impact, still more to do.
        </Section>

        <Section>
          find me on X <Link href="https://x.com/0xDavidR" target="_blank">@0xDavidR</Link>
        </Section>

        <Section style={{ fontSize: '12px', textAlign: 'center', color: '#666' }}>
          Apple Farm - Season 1 - 2024
        </Section>
        <Section>
          <Image 
            src="/images/scientist.svg" 
            alt="Apple Farm illustration" 
          />
        </Section>

      </Container>
    </Window>
  );
};